import { Node } from "./node";
import { Grid } from "./grid";

/**
 * The class GraphNode extends the abstract class Node
 * and describes the logical representation of a node in a graph.
 * This class implements the abstract methods draw and inParameter. 
 * The method draws a yellow circle at the coordinate of the node. 
 * The method inParameter determines whether a mouse click has been 
 * performed on this circle or not.
 */
export class GraphNode extends Node {

    //Draws the node.
    draw(ctx: CanvasRenderingContext2D, grid: Grid) {
        if (!this.visible) {
            return;
        }

        const centerCoordinates: [number, number] = grid.getCellCenter(this.rowIndex, this.colIndex);
        const xCenter: number = centerCoordinates[0];
        const yCenter: number = centerCoordinates[1];
        ctx.strokeStyle = 'black';
        ctx.lineWidth=1;

        ctx.beginPath();
        ctx.fillStyle = this.color;
        ctx.ellipse(xCenter, yCenter, grid.getWidthRadius(), grid.getHeightRadius(), 0, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.fill();
        ctx.closePath();

        ctx.fillStyle = 'black';
        ctx.font = 'bold ' +  (grid.getHeightCell()/3) + 'px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(this.name, xCenter, yCenter, Math.max(2 * grid.getWidthCell() / 3, 2 * grid.getHeightCell() / 3));

    }

    //Tolerenat inParameter implementation. Not completely accurate, works often.
    inParameter(e:MouseEvent, grid : Grid):boolean{
        const centerCoordinates: [number, number] = grid.getCellCenter(this.rowIndex, this.colIndex);
        const xCenter: number = centerCoordinates[0];
        const yCenter: number = centerCoordinates[1];

        let distance: number = Math.sqrt(Math.pow(xCenter-e.offsetX,2)+Math.pow(yCenter-e.offsetY,2));

        return distance <= grid.getWidthRadius() || distance <= grid.getHeightRadius();
    }

    clone():Node{
        let cloneNode: GraphNode = new GraphNode(this.rowIndex, this.colIndex,this.id);
        return cloneNode;
    }

}
